import { type VariantProps, cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

import type { CommonProps } from '../../types';
import { ChangeEvent, type JSX } from 'react';

export interface SwitchControllerProps
    extends CommonProps,
        VariantProps<typeof SwitchControllerStyles> {
    name: string;
    label?: string;
    value?: string;
    checked?: boolean;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
}

export const SwitchControllerStyles = cva(
    'inline-flex items-center cursor-pointer'
);

export const SwitchController = ({
    className,
    name,
    value,
    label,
    checked,
    disabled,
    onChange,
    testId = 'switch-controller',
    ...props
}: SwitchControllerProps): JSX.Element => {
    return (
        <label
            className={twMerge(SwitchControllerStyles({ className }))}
            {...props}
            data-testid={testId}
        >
            <input
                id={name}
                name={name}
                type="checkbox"
                value={value}
                checked={checked}
                className="peer sr-only"
                onChange={onChange}
                disabled={disabled}
            />
            <div className="peer-enabled:visible:bg-gray-700 peer-checked:bg-ta-brand-700 peer relative h-6 w-11 rounded-full bg-gray-300 after:absolute after:start-[2px] after:top-0.5 after:h-5 after:w-5 after:rounded-full after:border after:border-gray-300 after:bg-white after:transition-all after:content-[''] peer-checked:after:translate-x-full peer-checked:after:border-white peer-disabled:opacity-50 rtl:peer-checked:after:-translate-x-full"></div>
            <span className="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300"></span>
            {label && <span className="sr-only">{label}</span>}
        </label>
    );
};
